import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import flatpickr from "flatpickr";
import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate' ;
import { ajaxNewReminder, ajaxCreateNote, setFeedbackAlert } from '../redux/FeedbackRedux';
import Alert from '../Alert';

class PendingModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            focused: false,
            noteShow: false,
            note_text: ''
        }

        this.toggleFocus = this.toggleFocus.bind(this);

        var last_status = 0;

        setInterval(() => {
            if ($(".modal.fade.show").length !== last_status) {
                last_status = $(".modal.fade.show").length;

                this.setState({
                    focused: false,
                    noteShow: false,
                    note_text: ''
                })

                jQuery('.modal-email-checkbox').prop('checked', false);
                jQuery('.modal-text-checkbox').prop('checked', false);
            }
        }, 1000);
    }

    componentDidMount() {
        var defaultDate =  new Date();
        defaultDate.setDate(defaultDate.getDate() + 1);

        jQuery("#pendingModal").removeAttr("tabindex");
        jQuery('.js-datetimepicker').flatpickr({
            altInput: true,
            altFormat: "F j, Y h:i K",
            dateFormat: "Z",
            minDate: new Date().setTime(new Date().getTime()),
            enableTime: true,
            allowInput: true,
            defaultDate: defaultDate,
            focus:false,
            plugins:[new confirmDatePlugin({  showAlways: true})]
        });
    }

    handleClick(event) {
        var datetime = jQuery('.js-datetimepicker').val();
        var email = jQuery('.modal-email-checkbox').prop('checked');
        var text = jQuery('.modal-text-checkbox').prop('checked');
        if(!email && !text) {
            const alert = { alert: { alert_class: "warning", alert_message: __("Please select a notification method."), alert: true, alert_location: "pendingreminder" } };
            this.props.dispatch(setFeedbackAlert(alert));
        } else {
            if(jQuery('.reminder-button.disabled').length < 1) {
                if (this.state.noteShow && this.state.note_text !== '') {
                    this.props.dispatch(ajaxCreateNote( "Reason for setting to pending: " + this.state.note_text, this.props.state.current_user, this.props.feedback, null, this.props.state));
                    this.setState({focused: false, noteShow: false, note_text: ''});
                }
                this.props.dispatch(ajaxNewReminder(datetime,email,text,this.props.feedback, this.props.state));
            }
        }
    }

    handleNoteShow(event) {
        this.setState({...this.state, noteShow: true});
    }

    toggleFocus() {
        this.setState({...this.state, focused: !this.state.focused});
    }

    handleTextChange(event) {
        var text = event.target.value;
        this.setState({
            note_text: text,
        });
    }

	render () {
        return (
            <div className="col-sm-12 mt-0 pl-0 pr-0 forward-history anim-slide-in-top">
                <Alert alert={this.props.state.alert} location={'pendingreminder'}/>
                { __('You are marking a Feedback as "Pending". You can set a reminder to come back to this Feedback by selecting a future date and time, and notification method.') }
                <div className="row">
                    <div className="col-sm-12 mt-4">
                        <h5>{ __('Choose Notification Date/Time') }</h5>
                        <div className="input-group feedback-form-control border">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="fas fa-calendar-alt"></i>
                                </span>
                            </div>
                            <input className="js-datetimepicker" type="date" name="datetime"  required/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 mt-3"><h5>{ __('Choose Notification Method') }</h5></div>
                    <div className="col-sm-6 d-flex align-items-center cursor-pointer">
                        <label className="mb-0 w-100 pb-1 pt-1 pl-2 pr-2 d-flex align-items-center border rounded"><i className="fas text-primary fa-envelope mr-2"></i> { __('Email') } <input type="checkbox" name="email" className="ml-auto modal-email-checkbox" /> </label>
                    </div>
                    <div className="col-sm-6 d-flex align-items-center cursor-pointer">
                        <label className="mb-0 w-100 pb-1 pt-1 pl-2 pr-2 d-flex align-items-center border rounded"><i className="fas text-primary fa-comments mr-2"></i> { __('Text') } <input type="checkbox" name="text" className="ml-auto modal-text-checkbox" /> </label>
                    </div>
                    <div className="col-sm-12 mt-4 mb-4 text-right d-flex">
                        <button onClick={this.handleNoteShow.bind(this)} className="btn btn-outline-primary mr-3">{ __('Add Internal Note') }</button>
                        <button onClick={this.handleClick.bind(this)} className="btn btn-primary reminder-button"><i className="fas fa-clock mr-2"></i> { __('Set Reminder and Continue') }</button>
                    </div>
                    <div className="col-sm-12">
                        {
                            this.state.noteShow && <textarea
                                onFocus={this.toggleFocus}
                                onBlur={this.toggleFocus}
                                value={this.state.note_text}
                                onChange={this.handleTextChange.bind(this)}
                                className="note-textarea second-input input-primary w-100 grey-place" rows={6}
                                placeholder={this.state.focused ? '' : __('Let your teammates know why you are setting this to pending...')} />
                        }

                    </div>
                </div>
            </div>
        );

	}
}

function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(PendingModal);
